<template>
  <div class="footer">
    <!--<div class="links">-->
    <!--<a-->
    <!--href="https://pro.loacg.com/"-->
    <!--target="_blank"-->
    <!--&gt;Pro 首页</a>-->
    <!--<a-->
    <!--href="https://github.com/sendya/ant-design-pro-vue"-->
    <!--target="_blank"-->
    <!--&gt;-->
    <!--<a-icon type="github" />-->
    <!--</a>-->
    <!--</div>-->
    <div class="copyright" v-if="$store.state.user_type == 1">
      <a href="https://beian.miit.gov.cn/" target="_blank" style="text-decoration: none; color: rgba(0, 0, 0, 0.45)">
        <a-icon type="copyright" />
        <span>
          {{ online ? '江苏锁安科技 苏ICP备17043972号-3' : '南京迈特望科技股份有限公司 苏ICP备05059565号-7' }}
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GlobalFooter',
  data() {
    return {}
  },
  computed: {
    online() {
      return location.host == 'lockan.maitewang.com' || location.host == 'sjlockan.maitewang.com'
    },
  },
}
</script>

<style lang="less" scoped>
.footer {
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;

    a {
      color: rgba(0, 0, 0, 0.45);

      &:hover {
        color: rgba(0, 0, 0, 0.65);
      }

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }
  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}
</style>
